import type {Schemas} from 'api/dto.generated';
import type {BulkUpdateSummary} from '../types';
import {mapBulkUpdateFieldAndAction} from './mapBulkUpdateFieldAndAction';

export const mapBulkUpdateSummaryDto = (
  dto: Schemas.BulkUpdateSummary,
): BulkUpdateSummary => {
  return {
    id: dto.id,
    status: dto.status,
    items: dto.items,
    ...mapBulkUpdateFieldAndAction(dto.field, dto.action),
    created: dto.created * 1000,
    completed: dto.completed ? dto.completed * 1000 : undefined,
    ...dto.items,
  };
};
